'use strict';

/**
 * All JS for any action of the PsaMailingLists on the server side
 */
if (waApp.controllers.PsaMailingLists == undefined) {
	waApp.controllers.PsaMailingLists = {};
}

waApp.controllers.PsaMailingLists.NewsletterRecipients = {
	edit: function() {
		waGaEvents.updateMailingLists('#mailinglist-update-form');
	}
}
